// hooks/useAutoSave.js
import { useEffect, useRef, useState } from 'react'

/**
 * Hook pour auto-save avec debounce
 */
export function useAutoSave(value, onSave, delay = 1000) {
  const [status, setStatus] = useState('idle') // idle | saving | saved
  const timeoutRef = useRef(null)
  const previousValueRef = useRef(value)

  useEffect(() => {
    // Skip si valeur identique
    if (value === previousValueRef.current) return

    // Clear timeout précédent
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    setStatus('pending')

    // Nouveau timeout
    timeoutRef.current = setTimeout(async () => {
      setStatus('saving')
      try {
        await onSave(value)
        setStatus('saved')
        previousValueRef.current = value

        // Reset après 2s
        setTimeout(() => {
          if (status === 'saved') setStatus('idle')
        }, 2000)
      } catch (err) {
        console.error('Auto-save failed:', err)
        setStatus('error')
      }
    }, delay)

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [value, onSave, delay])

  return { status }
}
